import { AppModule } from '@nizza/core';
import { customizeLiveStore } from './stores';

export const customizeLiveModule: AppModule = {
  key: 'customize-live',
  label: 'Customize live',
  stores: [customizeLiveStore],
};
